import { useContext } from "react";
import { OrderContext } from "./OrderProvider";

export default function OrderOptions() {
  const { state, dispatch } = useContext(OrderContext);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        padding: "5px",
        marginBottom: "10px",
      }}
    >
      <div
        className={`main-form-body-orderheader ${
          state.orderType === "1" ? "main-form-body-orderheader-active" : ""
        }`}
        onClick={() => {
          dispatch({ type: "SET_ORDER_TYPE", value: "1" });
        }}
      >
        {" "}
        <input
          type="radio"
          name="order_type"
          value="1"
          checked={state.orderType === "1"}
        />
        <p>Single Order</p>
      </div>
      <div
        className={`main-form-body-orderheader ${
          state.orderType === "2" ? "main-form-body-orderheader-active" : ""
        }`}
        onClick={() => {
          dispatch(
            { type: "SET_ORDER_TYPE", value: "2" }
            // { type: "SET_SELECTED_PAYMENT_METHOD", value: "PM004" }
          );
        }}
      >
        {" "}
        <input
          type="radio"
          name="order_type"
          value="2"
          checked={state.orderType === "2"}
        />
        <p>Bulk Order</p>
      </div>
    </div>
  );
}
